// extracted by mini-css-extract-plugin
module.exports = {"root":"v7csc","ul":"_36cr3","ol":"_3jBpE"};